import React from 'react';
import { useHistory } from 'react-router-dom';
import { Button } from 'antd-v5';
import { ShareAltOutlined } from '@ant-design/icons';
import useVendorByKey from '../../../../../../hooks/query/useVendorByKey';

const RequestedProducts = ({ products, onShare }) => {
  const history = useHistory();
  const { vendorId: rolexVendorId } = useVendorByKey('rolex');

  if (!products || products.length === 0) {
    return (
      <div className="qv-section">
        <h3 className="rolex-section-title">Requested Products</h3>
        <span className="qv-section-empty">No requested products</span>
      </div>
    );
  }

  return (
    <div className="qv-section">
      <div
        className="qv-section-header"
        style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
      >
        <h3 className="rolex-section-title" style={{ margin: 0 }}>
          Requested Products
        </h3>
        {onShare && (
          <Button icon={<ShareAltOutlined />} onClick={() => onShare(products)}>
            Share with Client
          </Button>
        )}
      </div>
      <div className="rolex-product-list">
        {products.map(product => {
          const name = product.collectionName || product.name;
          const canNavigate = !!(rolexVendorId && product.vendorItemId);
          const handleClick = () => {
            if (!canNavigate) return;
            history.push(`/Products?vendorId=${rolexVendorId}&productId=${product.vendorItemId}`);
          };
          return (
            <div key={product.vendorItemId || product.id} className="rolex-product-card">
              {product.image ? (
                <img className="rolex-product-card__image" src={product.image} alt={name} />
              ) : (
                <div className="rolex-product-card__image" />
              )}
              <div className="rolex-product-card__info">
                {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions */}
                <span
                  className="rolex-product-card__name"
                  style={{ color: '#1677ff', cursor: canNavigate ? 'pointer' : 'default' }}
                  onClick={handleClick}
                >
                  {name}
                </span>
                <span className="rolex-product-card__model">{product.mpn || product.modelNumber}</span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default RequestedProducts;
